import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export const PeriodoFiltro = ({ desde, ate, onChange, testid }) => (
  <div className="flex items-center gap-1.5 flex-wrap text-[11px] text-slate-500" data-testid={testid}>
    <span>De</span>
    <Input type="date" value={desde} onChange={(e) => onChange({ desde: e.target.value, ate })} className="h-7 w-[8.5rem] text-xs" data-testid={`${testid}-desde`} />
    <span>até</span>
    <Input type="date" value={ate} onChange={(e) => onChange({ desde, ate: e.target.value })} className="h-7 w-[8.5rem] text-xs" data-testid={`${testid}-ate`} />
    {(desde || ate) && <button className="text-sky-600 hover:underline" onClick={() => onChange({ desde: "", ate: "" })}>limpar</button>}
  </div>
);

export const CarregarMais = ({ visible, onClick, testid }) => visible ? (
  <Button variant="outline" size="sm" className="w-full text-xs" onClick={onClick} data-testid={testid}>Carregar mais</Button>
) : null;
